import { REQUESTED_MQL_PLUS_PRICING, RECEIVED_MQL_PLUS_PRICING, REQUEST_MQL_PLUS_PRICING_FAILED } from '../actions/GetMqlPlusPricing';

const initialState = {
  loading: true,
  data: {},
};

const mqlPlusPricing = (state = initialState, action) => {
  switch (action.type) {
    case REQUESTED_MQL_PLUS_PRICING :
      return initialState;
    case RECEIVED_MQL_PLUS_PRICING :
      return {
        data: action.data,
        loading: false,
      };
    case REQUEST_MQL_PLUS_PRICING_FAILED:
      return Object.assign({}, initialState, {
        loading: false,
      });
    default:
      return state;
  }
};

export default mqlPlusPricing;
